export enum MobileBrowserTypes {
    UNITY = 'Unity'
}
